<template>
    <vx-card>
        <vs-row>
            <vs-col vs-align="left" vs-w="6">
                <vs-button
                    id="addResource"
                    color="primary"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-plus"
                    @click="showFormCreate"
                >
                    Ajouter une nouvelle grille
                </vs-button>

                <DialogPrompt
                    :active.sync="showPopup"
                    :title="getDataPrompt.title"
                    cancel-text="Annuler"
                    accept-text="Enregistrer"
                    :button-accept="getDataPrompt.btnAccept"
                    :is-valid="!formError"
                    @cancel="resetResource(); resetSearchParams()"
                    @close="resetResource(); resetSearchParams()"
                    @accept="saveResource"
                >
                     <GridForm
                        v-model="resource"
                        :type="formType"
                        @error="setFormError"
                    />
                </DialogPrompt>

                <DialogPrompt
                    :active.sync="showPopupOccupationSkill"
                    :title="can('update', 'occupation_skills', resourceOccupationSkill.id) ? 'Modifier un savoir faire' : 'Consulter un savoir faire'"
                    cancel-text="Fermer"
                    accept-text="Enregistrer"
                    :button-accept="can('update', 'occupation_skills', resourceOccupationSkill.id) ? 'filled' : 'false'"
                    :is-valid="!OSFormError"
                    @cancel="resetResourceOccupationSkill"
                    @accept="storeResourceOccupationSkill"
                    @close="resetResourceOccupationSkill"
                >
                    <OccupationSkillForm
                        v-model="resourceOccupationSkill"
                        :type="can('update', 'occupation_skills', resourceOccupationSkill.id) ? 'update' : 'show'"
                        @error="setOSFormError"
                    />
                </DialogPrompt>

            </vs-col>
            <vs-col vs-type="flex" vs-align="left" vs-w="6" />
        </vs-row>

        <vs-table
            :sst="true"
            @search="eventSearchItems"
            @sort="eventSortByCol"
            search
            :no-data-text="loading ? `Chargement de vos données...` : `Aucune donnée à afficher`"
            style="width:100%"
            :data="itemsData"
            :loading="true"
            >
            <template slot="thead">
                <vs-th>
                    <Sort name="title" @sort="eventSortByCol">Grille</Sort>
                </vs-th>
                <vs-th>
                    <Sort name="type" @sort="eventSortByCol">Type</Sort>
                </vs-th>
                <vs-th>
                    <Sort name="sector_id" @sort="eventSortByCol">Filière</Sort>
                </vs-th>
                <vs-th>
                    <Sort name="updated_at" @sort="eventSortByCol" :value="apiParams.sortBy['updated_at']">Modifié le</Sort>
                </vs-th>
                <vs-th>
                    Savoir-faire
                </vs-th>
                <vs-th></vs-th>
            </template>

            <template>
                <vs-tr v-for="(item, i) in items.data" :key="i">
                    <vs-td>
                        {{ get(item, ':title') }}
                    </vs-td>
                    <vs-td>
                        {{ get(item, ':type') }}
                    </vs-td>
                    <vs-td>
                        {{ get(item, ':sector.title') }}
                    </vs-td>
                    <vs-td>
                        {{ localeDateTime(get(item, ':updated_at')) }}
                    </vs-td>
                    <vs-td>
                        <vs-chip v-for="(os, index) in getOccupationSkillablesOrdered(item)" :key="`os_${index}`" :color="os.resource == 'OccupationSkill' ? 'primary' : null">
                            <span 
                                name="zone" 
                                style="cursor: pointer !important; min-height: 26px; min-width: 26px; padding-top: 6px;" 
                                v-tooltip="tooltipContent(os)"
                            >
                                {{ os.title }}
                            </span>
                        </vs-chip>
                    </vs-td>
                    <vs-td class="action">
                        <div class="action-wrapper">
                            <vs-button
                                v-if="can('update', 'grids', item.id)"
                                :id="'update_' + i"
                                v-tooltip="'Modifier'"
                                color="primary"
                                type="border"
                                icon-pack="feather"
                                icon="icon-edit"
                                @click.stop="showFormUpdate(item)"
                            />

                            <vs-button
                                :id="'export-' + i"
                                v-tooltip="'Exporter les Savoir-Faire'"
                                color="primary"
                                type="border"
                                icon-pack="feather"
                                icon="icon-download"
                                target="_blank"
                                :href="makeExportUrl(item)"
                            />

                            <vs-button
                                    v-if="can('create', 'grids', item.id)"
                                    :id="'create-' + i"
                                    v-tooltip="'Dupliquer'"
                                    color="primary"
                                    type="border"
                                    icon-pack="feather"
                                    icon="icon-copy"
                                    @click="duplicateResource(item)"
                                />

                            <vs-button
                                v-if="can('delete', 'grids', item.id)"
                                :id="'delete' + i"
                                v-tooltip="'Supprimer'"
                                color="primary"
                                type="border"
                                icon-pack="feather"
                                icon="icon-trash"
                                @click.stop="removeResource(item)"
                            />
                        </div>
                    </vs-td>
                </vs-tr>
            </template>

        </vs-table>

        <vs-row>
            <vs-col class="mt-4" v-if="items.total > 0">
                <vs-pagination :total="Math.ceil(items.total / apiParams.perpage)" v-model="currentPage"></vs-pagination>
            </vs-col>
        </vs-row>
    </vx-card>

</template>

<script>

import GridForm from '@components/views/rh/referentiel/grid/GridForm';
import { localeDateTime } from "@assets/utils/helpers/helpers.js";
import OccupationSkillForm from "@components/views/rh/referentiel/occupation-skill/OccupationSkillForm";

export default {
    name: 'Grids',
    components: {
        GridForm, OccupationSkillForm
    },
    props: {
        api: {
            type: String
        },
        perpage: {
            type: String
        }
    },
    data() {
        return {
            localeDateTime,
            log: console.log,
            config: [],
            currentPage: 1,
            loading: false,
            showPopup: false,
            showPopupOccupationSkill: false,
            isFormCreation: true,
            OSFormError: true,
            resource: {
                title: null,
                sector: null,
                establishment: null,
                occupation_skills: []
            },
            resourceOccupationSkill: {},
            formError: true,
            formType: "create",
            prompt: {
                show: {
                    title: 'Consulter une grille',
                    btnAccept: 'false'
                },
                create: {
                    title: 'Ajouter une grille',
                    btnAccept: 'filled'
                },
                update: {
                    title: 'Modifier une grille existante',
                    btnAccept: 'filled'
                }
            }
        }
    },

    watch: {
        loading(value) {
            if (value) {
                this.$vs.loading()
            } else {
                this.$vs.loading.close()
            }
        }
    },

    computed: {
        getDataPrompt() {
            switch(this.formType) {
                case 'show':
                    return this.prompt.show
                    break;
                case 'create':
                    return this.prompt.create
                    break;
                case 'update':
                    return this.prompt.update
                    break;
                default:
                    return this.prompt.show
            }
        },
    },

    methods: {

        showFormCreate() {
            this.resetResource();
            this.formType = "create";
            this.showPopup = true
        },

        showFormUpdate(resource) {
            this.setResource(resource);
            this.formType = "update";
            this.showPopup = true
        },

        saveResource() {
            let data = JSON.parse(JSON.stringify(this.resource));
                data.sector_id = data.sector.id;
                delete data.sector

            if (data.id) {
                this.apiUpdate(data, data.id,
                    (resp) => this.loadItems(),
                    (err)  => this.showPopup = true
                );
            } else {
                this.apiCreate(data,
                    (resp) => this.loadItems(),
                    (err)  => this.showPopup = true
                );
            }
        },

        removeResource(resource) {
            this.apiDelete(resource.id, () => this.loadItems());
        },

        setResource(data) {
            this.resource = JSON.parse(JSON.stringify(data));
        },

        resetResource() {
            this.resource = {
                id: null,
                title: null,
                sector: null,
                establishment: null,
                occupation_skills: [],
                admin_occupation_skills: []
            }
        },

        duplicateResource(resource) {
            this.setResource({...resource});
            this.formType = "create";
            this.showPopup = true
        },

        resetResourceOccupationSkill() {
            this.resourceOccupationSkill = {};
        },

        showAdminOccupationSkill(item) {
            this.resourceOccupationSkill = JSON.parse(JSON.stringify(item));
            this.resourceOccupationSkill.skills = this.resourceOccupationSkill.adminskills

            this.showPopupOccupationSkill = true;
        },

        showOccupationSkill(item) {
            this.resourceOccupationSkill = JSON.parse(JSON.stringify(item));
            this.showPopupOccupationSkill = true;
        },

        tooltipContent(item) {
            return {
                content: item.description,
                placement: 'top-start',
                classes: ['job-description']
            }
        },

        setOSFormError(value) {
            this.OSFormError = value;
        },

        storeResourceOccupationSkill() {
            let data = window._.cloneDeep(this.resourceOccupationSkill)
            data.sector = data.sector.id;

            if (data.establishment) {
                data.establishment_id = data.establishment.id
            }

            data['_method'] = 'PATCH';

            let dataform = objectToFormData(data);

            window.axios({
                method: 'post',
                url: `/api/referentiel/occupation-skills/${data.id}`,
                data: dataform,
                headers: {'Content-Type': 'multipart/form-data'}
            })
            .then(response => {
                if (response.status === 200 && response.data != '') {
                    this.notifySuccess('Succès', 'Élement modifié avec succès !')
                    this.loadItems();
                } else {

                    this.notifyError('Erreur', `Une erreur est survenue lors de la modification`)
                }
            })
            .catch((err, data) => {
                console.log(err.response);
                this.notifyErrorValidation(err)
                this.showPopupOccupationSkill = true
            })
        },

        setFormError (value) {
            this.formError = value;
        },

        makeExportUrl(resource) {

            let url = `/rh/referentiel/savoir-faire/export-pdf`;
            let nbSf = 0;
            for (var i in resource.occupation_skills) {
                url += i == 0 ? '?' : '&';
                url += `occupation_skills[]=${resource.occupation_skills[i].id}`;
                nbSf++;
            }

            for (var i in resource.admin_occupation_skills) {
                url += nbSf == 0 ? '?' : '&';
                url += `admin_occupation_skills[]=${resource.admin_occupation_skills[i].id}`;
                nbSf++;
            }

            return url;
        },

        getOccupationSkillablesOrdered(resource) {
            let occupationSkillables = [
                ...resource.admin_occupation_skills,
                ...resource.occupation_skills
            ];

            return occupationSkillables.sort((a, b) => a.pivot.order - b.pivot.order);
        },
        resetSearchParams() {
            const searchParams = new URLSearchParams(window.location.search);

            if (searchParams.has('create') || searchParams.has('os')) {
                history.replaceState({}, "", window.location.pathname);
            }
        },

    },
    created() {
        this.apiParams.include = [
            'sector', 
            'occupation_skills.jobs.service.establishment',
            'occupation_skills.sector',
            "occupation_skills.skills",
            'admin_occupation_skills.adminskills',
            'admin_occupation_skills.sector',
        ];
        this.apiParams.sortBy = {updated_at: "desc"};
        this.loadItems();

        // Ouvrir le formulaire de création au chargement de la page si argument create
        const searchParams = new URLSearchParams(window.location.search);
        if (searchParams.has('create')) {
            this.showFormCreate();
        }
    }
}
</script>
